import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NoResultsFound = () => {
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <img src="/icons/cross.png" />
      <Text type="titleM">{t('No hay resultados para los filtros seleccionados')}</Text>
    </Styles.MainContainer>
  )
}

export default NoResultsFound
